// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__r3ySO","inner":"styles_inner__PCaRG","content":"styles_content__eveDK","title":"styles_title__FJHs3","info":"styles_info__pproS","buttonWrap":"styles_buttonWrap___TnyF"};
module.exports.__checksum = "20c153857804"